<template>
  <div v-if="loaded"
       class="page-learn-ability-test"
  >
    <result-card v-if="result.length !== 0"
                 class="page-learn-ability-test-share-result-card"
                 :class="{ 'active': testDone  }"
                 ref="resultCard"
                 :user-info="userInfo"
                 :result-list="result"
    />
    <landing-page v-if="showLandingPage"
                  @show-begin-page="handleShowTestPage"
    />
    <begin-page v-if="showBeginPage"
                @show-test-page="handleShowTestPage"
    />
    <test-page v-if="showTestPage"
               @test-result="handleTestResult"
    />
    <result-page v-if="showResultPage"
                 @show-share-hint="handleShowShareHint"
    />
    <result-card-page v-if="showResultCardPage"
                      :result-img="resultImg"
                      @test-again="handleTestAgain"
    />
    <ym-loading v-if="showLoading"
                class="page-learn-ability-test-loading-icon"
                type="snake"
                color="#24b1b2"
    >
    </ym-loading>
  </div>
</template>

<script>
  import { Loading } from '@ymba/ym-ui';
  import { before, decorator } from 'ym-reporter-vue';
  import LandingPage from '@/pages/2020/LearnAbilityTest/components/LandingPage';
  import BeginPage from '@/pages/2020/LearnAbilityTest/components/BeginPage';
  import TestPage from '@/pages/2020/LearnAbilityTest/components/TestPage';
  import ResultPage from '@/pages/2020/LearnAbilityTest/components/ResultPage';
  import ResultCard from '@/pages/2020/LearnAbilityTest/components/ResultCard';
  import ResultCardPage from '@/pages/2020/LearnAbilityTest/components/ResultCardPage';
  import shareMixin from '@/mixins/share';
  import { isWeiXinBrowser } from '@/utils';
  import { getStaticShareInfo } from '@/services/app';

  export default {
    name: 'PageLearnAbilityTest',
    mixins: [shareMixin],
    metaInfo() {},
    components: {
      'ym-loading': Loading,
      LandingPage,
      BeginPage,
      TestPage,
      ResultPage,
      ResultCard,
      ResultCardPage,
    },
    data() {
      return {
        loaded: false,

        showLandingPage: true,
        showBeginPage: false,
        showTestPage: false,
        showResultPage: false,
        showResultCardPage: false,

        testDone: false,
        showLoading: false,

        userInfo: null,
        result: [],
        resultImg: '',
      };
    },
    methods: {
      async getStaticShareInfo() {
        await getStaticShareInfo('MW.marketingCollection_learn_index');
      },
      @decorator(before(function () {
        this.$reporter.report('MARKETING_LEARNABILITYTEST_SHARE_CLICK');
      }))
      recordShare() {
        setTimeout(() => {
          if (this.testDone) {
            this.showResultPage = false;
            this.handleCreateCard();
          }
        }, 1000);
      },
      shareSuccessListener() {
        this.$wechat.once('triggerShareAppMessage', () => {
          // 好友
          this.recordShare();
        });
        this.$wechat.once('triggerShareTimeline', () => {
          // qq空间 朋友圈
          this.recordShare();
        });
      },
      handleShowBeginPage() {
        this.showLandingPage = false;
        this.showBeginPage = true;
      },
      handleShowTestPage() {
        this.userInfo = { userName: '彩蛋', age: 18 };
        this.showLandingPage = false;
        this.showTestPage = true;
      },
      handleShowShareHint() {
        this.testDone = true;
      },
      async handleCreateCard() {
        this.showLoading = true;
        // 生成分享图片并获取src
        const resultImgDom = await this.$refs.resultCard.generateImage();
        this.resultImg = resultImgDom.src;
        this.showResultCardPage = true;
        this.showLoading = false;
      },
      handleTestResult(data) {
        this.showTestPage = false;
        this.result = data;
        this.showResultPage = true;
      },
      resetData() {
        this.userInfo = null;
        this.result = [];
        this.resultImg = '';
        this.testDone = false;
      },
      handleTestAgain() {
        this.resetData();
        this.showResultCardPage = false;
        this.showLandingPage = true;
      },
    },
    created() {
      this.getStaticShareInfo();
      this.shareSuccessListener();
      if (isWeiXinBrowser()) {
        this.loaded = true;
      } else {
        this.$dialog.confirm({
          title: '温馨提示',
          message: '请在微信内打开本页面',
        });
      }
    },
  };
</script>

<style scoped lang="less">
  .page-learn-ability-test {
    box-sizing: border-box;
    height: 100%;

    &-loading-icon {
      position: fixed;
      top: 50%;
      left: calc(50% - 30px);
    }

    &-share-result-card {
      position: absolute;
      top: 0;
      left: 0;
      width: 750px;
      height: 1334px;
      z-index: -2;
      display: none;
      &.active {
        display: block;
        height: 1750px;
      }
    }
  }

</style>
